/* eslint-disable */
import React from 'react';

import { PreviewItem, PreviewTitle, PreviewWrapper } from '../styles';

function Preview({
    inputMode,
    targetField,
    selectedKey,
    selectedDictionary,
    selectedItems,
    dataType,
    customValue,
    valueToSave,
}) {
    if (inputMode === 'dictionary') {
        if (targetField === 'external_key' && !selectedKey) return null;
        if (targetField === 'external_data' && selectedItems.length === 0) return null;
    }

    const formatValue = (value) => {
        if (value === '' || value === null || value === undefined) {
            return '(пусто)';
        }
        if (typeof value === 'object') {
            return JSON.stringify(value, null, 2);
        }
        return String(value);
    };

    const getExternalKeyValue = () => {
        if (inputMode === 'custom') {
            return targetField === 'external_key' ? formatValue(customValue) : '(не изменится)';
        }

        if (selectedKey && selectedDictionary) {
            const content = selectedDictionary.content || {};
            const keyValue = dataType === 'key' ? selectedKey : content[selectedKey];
            return formatValue(keyValue);
        }

        return '(не изменится)';
    };

    return (
        <PreviewWrapper>
            <PreviewTitle>📋 Предпросмотр сохранения</PreviewTitle>
            <PreviewItem>
                <strong>external_key:</strong>
                <code>
                    {getExternalKeyValue()}
                </code>
            </PreviewItem>
            <PreviewItem>
                <strong>external_data:</strong>
                <code>
                    {targetField === 'external_data' ? formatValue(valueToSave) : '(не изменится)'}
                </code>
                {targetField === 'external_data' && inputMode === 'dictionary' && selectedItems.length > 0 && (
                    <div
                        style={{
                            marginTop: 12,
                            padding: 12,
                            background: '#f0f5ff',
                            borderRadius: 4,
                        }}
                    >
                        <div
                            style={{
                                fontSize: '13px',
                                fontWeight: 'bold',
                                marginBottom: 8,
                                color: '#1890ff',
                            }}
                        >
                            Источники данных:
                        </div>
                        {selectedItems.map((item) => {
                            const itemKey = `${item.dictionaryId}-${item.integrationKey || item.key}`;

                            return (
                                <div
                                    key={itemKey}
                                    style={{
                                        marginBottom: 6,
                                        paddingLeft: 12,
                                        fontSize: '12px',
                                        lineHeight: '1.6',
                                    }}
                                >
                                    <div>
                                        <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                            {item.integrationKey || item.key}
                                        </span>
                                        {' → '}
                                        <span style={{ color: '#52c41a' }}>
                                            {item.dataType === 'key' ? 'Ключ' : 'Значение'}
                                        </span>
                                    </div>
                                    <div style={{ color: '#666', fontSize: '11px', marginTop: 2 }}>
                                        Справочник:
                                        {' '}
                                        {item.dictionaryName}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </PreviewItem>
        </PreviewWrapper>
    );
}

export default Preview;
